// eslint-disable-next-line import/no-unresolved
import { Footer } from 'footer/components';
import { StyleSheetManager } from 'styled-components';

import isPropValid from '@emotion/is-prop-valid';
import { TranslationProvider } from '@storebrand-digital/fms-translations-react';
import { EnvironmentInfo } from '@storebrand-digital/insurance-environment-info';
import FlagProvider from '@unleash/proxy-client-react';
import en from '../fms-fallbacks/fallback-en.json';
import no from '../fms-fallbacks/fallback-no.json';

import { config } from '../../config';
import { CacheProvider } from '../CacheProvider';
import { CorporateContextProvider } from '../CorporateContext';
import GlobalStyle from '../global-style';
import { LayoutProvider } from '../layout/LayoutProvider';
import ErrorBoundary from '../shared/components/ErrorBoundary';
import { unleashConfig } from '../utils/unleash';
import App from './App';
import { Navbar } from './Navbar';

// This implements the default behavior from styled-components v5
function shouldForwardProp(propName: string, target: any) {
  if (typeof target === 'string') {
    // For HTML elements, forward the prop if it is a valid HTML attribute
    return isPropValid(propName);
  }
  // For other elements, forward all props
  return true;
}

const AppWithProviders = () => {
  return (
    <StyleSheetManager shouldForwardProp={shouldForwardProp}>
      <ErrorBoundary>
        <GlobalStyle />
        <EnvironmentInfo appName={config.name} />
        <FlagProvider config={unleashConfig}>
          <CacheProvider>
            <TranslationProvider
              document="insuranceclaimweb"
              clientId="insurance-claim-web"
              fallback={{ no, en }}
            >
              <CorporateContextProvider>
                <LayoutProvider>
                  <Navbar />
                  <App />
                  <Footer />
                </LayoutProvider>
              </CorporateContextProvider>
            </TranslationProvider>
          </CacheProvider>
        </FlagProvider>
      </ErrorBoundary>
    </StyleSheetManager>
  );
};

export default AppWithProviders;
